import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloating from "./components/WhatsAppFloating";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ZonesTarifs from "./pages/ZonesTarifs";
import Avis from "./pages/Avis";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/zones-tarifs" element={<ZonesTarifs />} />
          <Route path="/avis" element={<Avis />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppFloating />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
